/**
 * Check if the employee is repsonsable of the planning
 * 
 * @param {number} sid          the employee's ID
 * @param {object} planning     the planning obj
 * @returns {boolean}           true if is reponsible, false otherwise
 */
export const isEmployeeResponsable = (sid, planning) => {

    let isResponsable = false;

    if (planning && Object.hasOwn(planning, 'responsable') && planning.responsable) {
        const resonsableSID = parseInt(planning.responsable.id);
        const staffID = sid ? parseInt(sid) : null;

        if (staffID === resonsableSID) {
            isResponsable = true;
        }
    }

    return isResponsable;
};

/**
* Checks if the User is responsible of the planning
* @param {number} uid 
* @param {object} planning
* @returns {boolean}
*/
export const isUserResponsable = (uid, planning) => {

    let isResponsable = false;

    if (planning && Object.hasOwn(planning, 'responsable') && planning.responsable) {
        const resonsableUID = parseInt(planning.responsable.user_id);
        const userID = uid ? parseInt(uid) : null;

        if (userID === resonsableUID) {
            isResponsable = true;
        }
    }

    return isResponsable;
};

/**
 * Helper function check if the planning has a responsable set
 * 
 * @param {object} planning 
 * @returns {boolean}
 */
export const hasResponsable = (planning) => {

    if (planning && Object.hasOwn(planning, 'responsable') && planning.responsable) {
        return (planning.responsable);
    }

    return false;
};

/**
 * Helper function to check if an Employee has or not to send a report for a given Work Planning.
 * 
 * @param {number} sid  the staff ID (not the user ID)
 * @param {object} planning
 * @returns {boolean}
 */
export const shouldEmployeeSendReport = (sid, planning) => {

    if (hasResponsable(planning)) {
        if (isEmployeeResponsable(sid, planning)) {

            return true;
        }

        // console.log('The responsable is not the current user');

        return false;
    }

    // console.log('No responsable');

    return true;
};

/**
 * Helper function to get the current user's Staff ID.
 * 
 * @param {object} appData  The context APP
 * @returns number          The Staff ID or -1 on error
 */
export const getCurrentUserStaffID = (appData) => {
    return appData.userInfo?.staff?.id || -1;
};
